import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from '@/providers/RouterShim';
import useBranch from '../../../../data/branch/useBranch';
import useBranches from '../../../../data/branch/useBranches';
import { IconDirDown } from '../../../../styled-components/components/Icon';
import ScopeAvatar from '../../../../styled-components/components/ScopeAvatar';
import { Skeleton } from '../../../../styled-components/components/Skeleton';
import { urlToCfit } from '../../../../utils/cfit';
import { getInitials } from '../../../../utils/initials';
import ScopeFoldout from './ScopeFoldout';
import { ScopeSelect, ScopeSelectLabel } from './wrapper';

const Scope = () => {
  const { t } = useTranslation(['header', 'validation']);
  const { branchId } = useParams();
  const [branch] = useBranch();
  const [branches, requestBranches] = useBranches();

  const [scopeFoldout, setScopeFoldout] = useState(false);
  const onToggleScopeFoldout = () => setScopeFoldout(!scopeFoldout);

  const fallbackBranch = useMemo(
    () => (branchId ? branches?.find((x) => x.id === branchId) : undefined),
    [branches, branchId],
  );

  const selectedBranch = branch || fallbackBranch;

  const image = selectedBranch?.logo ? urlToCfit(selectedBranch.logo, { width: 225 }) : undefined;

  return (
    <>
      {scopeFoldout && <ScopeFoldout onClose={onToggleScopeFoldout} />}
      <ScopeSelect
        onClick={onToggleScopeFoldout}
        title={t('scopeSelect.openButton', { ns: 'header' })}
      >
        {requestBranches.isLoading ? (
          <ScopeAvatar loading />
        ) : (
          <ScopeAvatar
            image={
              image && selectedBranch
                ? {
                    src: image,
                    alt: selectedBranch.name,
                  }
                : undefined
            }
            initials={!selectedBranch?.logo ? getInitials(selectedBranch?.name) || '' : undefined}
          />
        )}
        <ScopeSelectLabel>
          {requestBranches.isLoading ? (
            <Skeleton $width="120px" $height="16px" />
          ) : (
            selectedBranch?.name || t('unknown', { ns: 'validation' })
          )}
        </ScopeSelectLabel>
        <IconDirDown />
      </ScopeSelect>
    </>
  );
};

export default Scope;
